import { Html, useProgress } from "@react-three/drei";
import "./ui/loader-style.css"

export default function Loader() {
    const { active, progress, errors, item, loaded, total } = useProgress();
    return <>
        <Html center>
            <div class="progress">
                <div class="progress-value" style={{width: progress + "%"}}></div>
            </div>
        </Html>;
    </> 
}